const ProductItems = [
  { name: 'RV, Breaking, & Towing Products', link: '/rv-products' },
  { name: 'Online Store', link: 'https://www.rv4x4.net.au/' },
]

export default ProductItems
